import { render, staticRenderFns } from "./ot-field-archetype.vue?vue&type=template&id=21661866&scoped=true&"
import script from "./ot-field-archetype.vue?vue&type=script&lang=ts&"
export * from "./ot-field-archetype.vue?vue&type=script&lang=ts&"
import style0 from "./ot-field-archetype.vue?vue&type=style&index=0&id=21661866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21661866",
  null
  
)

export default component.exports